import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';
import {
  Login,
  LoginCallback,
  Logout,
  RouteWithAuthorization,
} from '@spins-gcp/auth0-react';
import { AppProvider } from '../app/app-provider';

export function AuthWrapper() {
  const tokenCookieNames = ['access_token'];

  return (
    <ReactRouterRoutes>
      <Route path="/login" element={<Login />} />
      <Route path="/loginCallback" element={<LoginCallback />} />
      <Route path="/logout" element={<Logout />} />
      <Route
        path="*"
        element={
          <RouteWithAuthorization tokenCookies={tokenCookieNames}>
            <AppProvider />
          </RouteWithAuthorization>
        }
      />
    </ReactRouterRoutes>
  );
}

export default AuthWrapper;
